<template>
    <div id="AccountsDebtFilter" class="pb-10">
        <v-expansion-panels flat>
            <v-expansion-panel>
                <v-expansion-panel-header class="pa-0" hide-actions>
                    <template v-slot:default="{ open }">
                        <div class="d-flex align-center">
                            <div class="text-subtitle-1 font-weight-bold gray--text">Фильтр</div>
                            <v-icon color="gray" v-if="open">arrow_drop_up</v-icon>
                            <v-icon color="gray" v-if="!open">arrow_drop_down</v-icon>
                        </div>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="v-row">
                    <v-row>
                        <v-col cols="12" lg="6">
                            <v-text-field
                                label="Долг по лицевому счету, больше которого необходимо найти должника"
                                color="gray"
                                append-icon="search"
                                outlined
                                type="number"
                                hide-spin-buttons
                                v-model="filter.sum_debt"
                                class="v-col-2"
                            />
                        </v-col>
                        <v-col cols="6" lg="3">
                            <v-text-field
                                hide-spin-buttons
                                type="number"
                                color="gray"
                                append-icon="search"
                                outlined
                                v-model="filter.account_number"
                                label="Номер лицевого счета"
                            />
                        </v-col>
                        <v-col cols="6" lg="3">
                            <v-text-field color="gray" label="ФИО" append-icon="search" outlined v-model="filter.person_name" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <AddressSelector v-model="filter.selectedAddress" ref="addressSelector">
                                <v-text-field
                                    color="gray"
                                    append-icon="arrow_drop_down"
                                    placeholder="Выберите адрес"
                                    class="pointer"
                                    outlined
                                    readonly
                                    hide-details
                                    clearable
                                    v-model="filter.selectedAddress.address_full_name"
                                ></v-text-field>
                            </AddressSelector>
                        </v-col>
                        <v-col>
                            <v-select
                                color="gray"
                                :items="districts"
                                item-value="record_id"
                                item-text="district_name"
                                outlined
                                label="Выберите административный район"
                                v-model="filter.selectedDistrictRid"
                            />
                        </v-col>
                    </v-row>
                    <div>
                        <div>Состояние услуг:</div>
                        <v-radio-group row v-model="filter.isServiceConnected">
                            <v-radio
                                color="gray"
                                v-for="stateService in stateServices"
                                :key="stateService.label"
                                :label="stateService.label"
                                :value="stateService.value"
                            ></v-radio
                        ></v-radio-group>
                    </div>
                    <div>
                        <div>Статус досудебного уведомления:</div>
                        <v-radio-group row v-model="filter.notice_status_type_rid">
                            <v-radio
                                color="gray"
                                v-for="stateStatus in stateStatuses"
                                :key="stateStatus.label"
                                :label="stateStatus.label"
                                :value="stateStatus.value"
                            ></v-radio
                        ></v-radio-group>
                    </div>
                    <div>
                        <v-btn color="white" outlined @click="resetFilter" class="mr-10 gray--text">Сбросить</v-btn>
                        <v-btn color="gray" class="white--text" @click="applyFilter">Применить</v-btn>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import AddressSelector from '@/components/administration/AddressSelector.vue';
import { mapGetters } from 'vuex';
import translate from '@/utils/translate.util';

export default {
    name: 'AccountsDebtFilter',
    components: { AddressSelector },
    props: ['filterModel'],
    computed: {
        ...mapGetters('refs', ['getDistricts']),
        districts() {
            return translate(this.getDistricts, 'full', this.$i18n.locale);
        },
        filter: {
            get() {
                return this.filterModel;
            },
            set(value) {
                this.$emit('update:filterModel', value);
            }
        }
    },
    data: function() {
        return {
            stateServices: [
                { label: 'Отображать все', value: 2 },
                { label: 'Отключена', value: 0 },
                { label: 'Подключена', value: 1 }
            ],
            stateStatuses: [
                { label: 'Отображать все', value: 0 },
                { label: 'Создано', value: 1 },
                { label: 'Вручено', value: 2 }
            ]
        };
    },
    methods: {
        applyFilter() {
            this.$emit('applyFilter');
        },
        resetFilter() {
            this.$emit('resetFilter');
        }
    }
};
</script>

<style>
#AccountsDebtFilter .v-expansion-panel-content__wrap {
    padding: 0;
}
</style>
